import moment from 'moment-timezone';
import {APP_TIMEZONE} from '@/plugins/filters/constants';
import Vue from 'vue';

const numberFormatter = new Intl.NumberFormat('en-UK', {
  style: "currency",
  currency: "GBP",
  minimumFractionDigits: 2
});

const isEmpty = (val) => {
  return val === undefined || val === null || val === "";
};

const emailDomainLowerCase = (value) => {
  if (!value) return value;
  return !/(?<=\@).*[A-Z]/.test(value);
}

const formatDateToUTC = (val, format) => {
  const time = moment.tz(val, APP_TIMEZONE);
  return createMoment(time, true).utc().format(format || 'yyyy-MM-DD HH:mm');
};

const createMoment = (val, isConstruct) => {
  const time = moment.tz(val, APP_TIMEZONE);
  return moment(time).utcOffset(moment.tz(APP_TIMEZONE).utcOffset(), isConstruct);
};

const addVat = (val) => {
  if (!val) {
    return 0;
  }

  const valIncludingVat = parseFloat(val) * (1 + Vue.prototype.$vatAmount);
  return valIncludingVat.toFixed(2);
}

export {
  isEmpty,
  numberFormatter,
  emailDomainLowerCase,
  formatDateToUTC,
  createMoment,
  addVat
}
